import classNames from 'classnames'
import { DataItem } from 'scrivito'

import { DataItemLink } from '@/Atomic/Atoms/DataItemLink'

import './StringText.scss'

export interface StringProps {
  variant?: 'default' | 'title' | 'subtitle' | 'link' | 'caption'
  value?: string
  onClick?: React.MouseEventHandler<HTMLSpanElement>
  dataItem?: DataItem
  href?: string
  wrapperClassName?: string
  className?: string
  children?: React.ReactNode
}

export const StringText: React.FC<StringProps> = ({
  variant = 'default',
  value,
  onClick,
  dataItem,
  href,
  wrapperClassName,
  className,
  children,
}) => {
  if (variant === 'link' && dataItem) {
    return (
      <div className={classNames('string-wrapper', wrapperClassName)}>
        <DataItemLink
          dataItem={dataItem}
          className={classNames('link', className)}
        >
          {children ?? value}
        </DataItemLink>
      </div>
    )
  }

  if (variant === 'link' && href) {
    return (
      <div className={classNames('string-wrapper', wrapperClassName)}>
        <a
          href={href}
          className={classNames('link', className)}
          onClick={onClick}
        >
          {children ?? value}
        </a>
      </div>
    )
  }

  return (
    <div className={classNames('string-wrapper', wrapperClassName)}>
      <span
        className={classNames(variant, className)}
        onClick={variant === 'link' ? onClick : undefined}
      >
        {children ?? value}
      </span>
    </div>
  )
}
